import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import Vuefire from "vuefire";
import Firebase from "./plugins/firebase";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(Vuefire);
Vue.use(Vuetify);
Vue.use(Firebase, { router });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js